module.exports = __webpack_public_path__ + "static/media/two.9f0541cf.jpg";